import { tokenAliasOrValue } from "./base";
import { FontFamilyTokenData } from "./font-family";
import { FontSizeTokenData } from "./font-size";
import { FontWeightTokenData } from "./font-weight";
import { LetterSpacingTokenData } from "./letter-spacing";
import { LineHeightTokenData } from "./line-height";
import { ParagraphIndentTokenData } from "./paragraph-indent";
import { ParagraphSpacingTokenData } from "./paragraph-spacing";
import { TextCaseTokenData } from "./text-case";
import { TextDecorationTokenData } from "./text-decoration";
import { z } from "zod";
export const TypographyValue = z.object({
    fontSize: FontSizeTokenData,
    fontFamily: FontFamilyTokenData,
    fontWeight: FontWeightTokenData,
    textDecoration: TextDecorationTokenData,
    textCase: TextCaseTokenData,
    letterSpacing: LetterSpacingTokenData.optional(),
    lineHeight: LineHeightTokenData.optional(),
    paragraphIndent: ParagraphIndentTokenData.optional(),
    paragraphSpacing: ParagraphSpacingTokenData.optional(),
});
export const TypographyTokenData = tokenAliasOrValue(TypographyValue);
